<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { CERTIFICATES_CONFIRMATION_TYPES } from "@/package/const/certificates-confirmation-types";
import MainModal from "@/package/components/MainModal.vue";
import MainSelect from "@/components/helpers/MainSelect.vue";
import MainButton from "@/components/helpers/MainButton.vue";
import MainCheckbox from "@/components/helpers/MainCheckbox.vue";

export default {
  name: "CertificatesBuyModal",

  emits: ["close", "confirm"],

  components: { MainButton, MainSelect, MainModal, MainCheckbox },

  props: {
    isShowModal: {
      type: Boolean,
      default: false,
    },

    isBuyCertLoading: {
      type: Boolean,
      default: false,
    },

    phone: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      CERTIFICATES_CONFIRMATION_TYPES,

      agreement: false,
      currentNominal: null,
      currentType: "whatsapp",
    };
  },

  watch: {
    isShowModal() {
      if (!this.isShowModal) {
        this.agreement = false;
        this.currentNominal = null;
        this.currentType = "whatsapp";
      }
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      certificatesNominals: (state) => state.certificates.certificatesNominals,
    }),

    ...mapGetters({
      formatCertificatesNominals: "certificates/formatCertificatesNominals",
    }),

    isDisabledConfirmButton() {
      return !this.currentNominal || !this.agreement || this.isBuyCertLoading;
    },

    currentTax() {
      if (!this.currentNominal) return "";

      return `Комиссия ${this.currentNominal.tax} RC`;
    },
  },

  methods: {
    ...mapActions({
      loadCertificatesNominals: "certificates/loadCertificatesNominals",
    }),

    closeModal() {
      if (!this.isBuyCertLoading) {
        this.$emit("close");
      }
    },
  },
};
</script>

<template>
  <MainModal
    class="certificates-buy-modal"
    :show-modal="isShowModal"
    @close="closeModal"
  >
    <h1>Оформление покупки</h1>

    <MainSelect
      class="certificates-buy-modal__selector"
      :title="'Выберите номинал сертификата'"
      :style-type="'background-white'"
      :selected-option.sync="currentNominal"
      :options="formatCertificatesNominals"
      :caption="currentTax"
    />

    <span class="divider" />

    <div class="certificates-buy-modal__confirmation-types confirmation-types">
      <h2>Способ подтверждения</h2>
      <p>
        Ваш подключенный номер <span>{{ phone }}</span>
      </p>

      <div class="confirmation-types__list">
        <div
          v-for="type in CERTIFICATES_CONFIRMATION_TYPES"
          :key="type.id"
          class="confirmation-types__item item"
        >
          <label>
            <img
              :src="require(`../../assets/icons/share/${type.icon}.svg`)"
              alt=""
            />
            {{ type.label }}
            <input
              v-model="currentType"
              :value="type.id"
              type="radio"
              name="confirmation-type"
            />
          </label>
        </div>
      </div>
    </div>

    <MainButton
      :title="'Перейти к подтверждению'"
      :color="'dark'"
      :loading="isBuyCertLoading"
      :disabled="isDisabledConfirmButton"
      @click="
        $emit('confirm', {
          type: currentType,
          nominal: currentNominal.value,
        })
      "
    />

    <MainCheckbox
      :id="'agreement'"
      v-model="agreement"
      class="certificates-buy-modal__checkbox"
      :model-value="agreement"
      :title="'Я ознакомлен с '"
      :link-text="'правилами покупки и активации сертификата'"
      href="https://esd.docs-lab.ru/document/download/136"
    />
  </MainModal>
</template>

<style lang="scss" scoped>
.certificates-buy-modal {
  ::v-deep .main-modal__container {
    max-width: 480px;
    width: 100%;
  }

  ::v-deep .main-checkbox input + label span {
    max-width: none;
  }

  h1 {
    @include title-3;
    color: $dark-primary;
    margin-bottom: 24px;
  }

  &__selector {
    ::v-deep .main-select {
      max-width: none;
    }

    ::v-deep .main-select__items {
      max-width: none;
    }
  }

  .divider {
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .confirmation-types {
    margin-bottom: 32px;

    > h2 {
      @include body-1-bold;
      color: $dark-primary;
      margin-bottom: 4px;
    }

    > p {
      @include text-2;
      color: $dark-primary;
      margin-bottom: 16px;

      > span {
        font-weight: 500;
      }
    }

    &__list {
      display: flex;
      flex-direction: column;
    }

    .item {
      width: 100%;

      &:not(:last-child) {
        margin-bottom: 16px;
      }

      > label {
        display: flex;
        align-items: center;
        cursor: pointer;
        @include text-2;
        color: $dark-primary;

        > img {
          min-width: 40px;
          width: 40px;
          height: 40px;
          margin-right: 8px;
        }
      }

      input {
        appearance: none;
        margin: 0 0 0 auto;
        width: 20px;
        height: 20px;
        border: 1.25px solid $light-sixth;
        background-color: $light-primary;
        border-radius: 50%;
        display: grid;
        place-content: center;

        &::before {
          content: "";
          width: 12px;
          height: 12px;
          border-radius: 50%;
          transform: scale(0);
          transition: 120ms transform ease-in-out;
          box-shadow: inset 1em 1em $gold-dark;
        }

        &:checked {
          border: 1.25px solid $gold-dark;

          &::before {
            transform: scale(1);
          }
        }
      }
    }
  }

  &__checkbox {
    margin-top: 16px;
  }
}
</style>
